module.exports = __webpack_public_path__ + "1fd03c3e725888efd37221947f187e4d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-soccer.png
// module id = 1971
// module chunks = 0